var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultBlot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 473,
    height: 413,
    viewBox: "0 0 473 413",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.174 58.7775C277.821 58.0373 344.36 -26.6435 406.739 8.56383C470.38 44.4835 473.921 135.894 472.125 208.882C470.378 279.86 457.425 362.004 397.114 399.587C340.499 434.866 271.276 389.24 206.174 374.607C162.581 364.809 118.897 359.043 85.3858 329.522C49.4465 297.863 29.1643 255.438 18.0462 208.882C2.23745 142.684 -18.722 94.587 34.5144 52.1105C89.1521 8.51602 136.247 59.4999 206.174 58.7775Z",
    fill: "#EAF3FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultBlot);
export default __webpack_public_path__ + "static/media/DefaultBlot.a017413decb4c9f5338550182b50c11f.svg";
export { ForwardRef as ReactComponent };